import { Navigate, Route, Routes } from "react-router";

import {
  AanleveringenDetail,
  AanleveringenOverview,
  BlogOverview,
  BlogPost,
  Integraties,
  Landing,
  OverOns,
  PublicLayout,
  VoorDrinkwaterbedrijven,
  VoorGemeenten,
  VoorProvincies,
  VoorWaterschappen,
} from "@/features/public";

export const PublicRoutes = () => (
  <Routes>
    <Route path="/public">
      <Route element={<PublicLayout />}>
        <Route index element={<Landing />} />
        <Route path="over-ons" element={<OverOns />} />
        <Route path="voor-gemeenten" element={<VoorGemeenten />} />
        <Route path="voor-waterschappen" element={<VoorWaterschappen />} />
        <Route path="voor-provincies" element={<VoorProvincies />} />
        <Route path="voor-drinkwaterbedrijven" element={<VoorDrinkwaterbedrijven />} />
        <Route path="integraties" element={<Integraties />} />
        <Route path="aanleveringen" element={<AanleveringenOverview />} />
        <Route path="aanleveringen/:type" element={<AanleveringenDetail />} />
        <Route path="blog" element={<BlogOverview />} />
        <Route path="blog/:slug" element={<BlogPost />} />
      </Route>
      <Route path="*" element={<Navigate to="/public" replace />} />
    </Route>
  </Routes>
);
